module.exports = __webpack_public_path__ + "static/media/card_game_item.aa4e9d5d.png";